<template>
  <div class="order">
    <p class="title">
      分钟数记录
      <span>可用：{{ point }}</span>
    </p>
    <el-table
      :data="tableData"
      style="width: 98%"
      empty-text="暂无数据"
      :header-cell-style="{ background: '#f4f4f4', color: '#666' }"
    >
        <el-table-column prop="createtime" label="记录时间" width="200"></el-table-column>
        <el-table-column prop="cause" label="变化原因" width="200"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="ai_drop" label="分钟数变化" width="120">
		</el-table-column>
        <el-table-column prop="effect_time" label="生效时间" width="220"></el-table-column>
        <el-table-column prop="expire_time" label="过期时间" width="220"></el-table-column>
        <!-- <el-table-column prop="after" label="剩余点数" width="120"></el-table-column> -->
    </el-table>
    <div class="pagination">
      <el-pagination layout="prev, pager, next" :total="total" :current-page="page" @current-change="userGetAiDropList"> </el-pagination>
    </div>
  </div>
</template>

<script>
import { userGetAiDropList } from "@/api/user";
export default {
  data() {
    return {
      page:1,
      point: 20,
      total:20,
      tableData: [

      ],
    };
  },
  mounted() {
    this.userGetAiDropList(1)
  },
  methods: {
    userGetAiDropList(page){
      this.page = page
      userGetAiDropList({page:this.page}).then(res=>{
        this.tableData = res.data.data.data
        this.point = res.data.ai_drop
        this.total = res.data.data.total
      })
    }
  }
};
</script>

<style lang="less">
.order {
  width: 100%;
  padding: 0 32px;
  .title {
    height: 65px;
    font-size: 20px;
    font-weight: 700;
    line-height: 65px;
  }
  .pagination {
    text-align: center;
  }
  .status1 {
    span {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #2d8af5;
      margin-right: 6px;
    }
  }
  .status2 {
    span {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #ddd;
      margin-right: 6px;
    }
  }
  .status3 {
    span {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #67c23a;
      margin-right: 6px;
    }
  }
}
</style>